import { render, staticRenderFns } from "./chatAside.vue?vue&type=template&id=5524fcc8&scoped=true"
import script from "./chatAside.vue?vue&type=script&lang=js"
export * from "./chatAside.vue?vue&type=script&lang=js"
import style0 from "./chatAside.vue?vue&type=style&index=0&id=5524fcc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5524fcc8",
  null
  
)

export default component.exports